import React from 'react';
import { motion } from 'framer-motion';
import { User, Eye, RotateCcw, ZoomIn, ZoomOut } from 'lucide-react';

interface AvatarViewerProps {
  meshUrl?: string;
}

const AvatarViewer: React.FC<AvatarViewerProps> = ({ meshUrl }) => {
  return (
    <div className="w-full h-full bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl border-2 border-dashed border-gray-300 flex flex-col items-center justify-center p-8">
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="text-center"
      >
        {/* Avatar Placeholder */}
        <div className="relative mb-6">
          <div className="w-32 h-32 bg-gradient-to-br from-brand-blue/20 to-brand-yellow/20 rounded-full flex items-center justify-center border-4 border-brand-blue/30">
            <User className="w-16 h-16 text-brand-blue/60" />
          </div>
          
          {/* Avatar Features */}
          <div className="absolute -top-2 -left-2 w-8 h-8 bg-brand-yellow rounded-full flex items-center justify-center">
            <div className="w-4 h-4 bg-white rounded-full"></div>
          </div>
          <div className="absolute -top-2 -right-2 w-8 h-8 bg-brand-yellow rounded-full flex items-center justify-center">
            <div className="w-4 h-4 bg-white rounded-full"></div>
          </div>
          
          {/* Nose */}
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-3 h-3 bg-brand-blue/40 rounded-full"></div>
          
          {/* Mouth */}
          <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 w-6 h-1 bg-brand-blue/40 rounded-full"></div>
        </div>
        
        <h3 className="text-lg font-semibold text-gray-700 mb-2">
          Avatar Preview
        </h3>
        <p className="text-gray-500 text-sm mb-4">
          {meshUrl ? '3D model loaded successfully' : 'No 3D model available'}
        </p>
        
        {/* Control Buttons */}
        <div className="flex space-x-3">
          <button className="p-2 bg-brand-blue/10 text-brand-blue rounded-lg hover:bg-brand-blue/20 transition-colors">
            <Eye className="w-4 h-4" />
          </button>
          <button className="p-2 bg-brand-blue/10 text-brand-blue rounded-lg hover:bg-brand-blue/20 transition-colors">
            <RotateCcw className="w-4 h-4" />
          </button>
          <button className="p-2 bg-brand-blue/10 text-brand-blue rounded-lg hover:bg-brand-blue/20 transition-colors">
            <ZoomIn className="w-4 h-4" />
          </button>
          <button className="p-2 bg-brand-blue/10 text-brand-blue rounded-lg hover:bg-brand-blue/20 transition-colors">
            <ZoomOut className="w-4 h-4" />
          </button>
        </div>
        
        <p className="text-xs text-gray-400 mt-4">
          3D visualization coming soon
        </p>
      </motion.div>
    </div>
  );
};

export default AvatarViewer; 